import WhatsappOptIn from './WhatsappOptIn';
import TermsAndPoliciesOptIn from './TermsAndPoliciesOptIn';

export { WhatsappOptIn, TermsAndPoliciesOptIn };
